// frontend/init/index.js

import './index.css';
import './import_resource_user_views';
import './set-initial-body-classes';
import './turbolinks-cleanup';
import './query-string-page-refresh';
import './setup-turbolinks-tracking';
import './setup-web-vitals';
